module.exports = __webpack_public_path__ + "static/media/card2.81c4f335.png";